<template>
    <v-container fluid>
        <v-card outlined>
            <v-card-subtitle>
                Listado de membresias por <strong>vencer</strong>.
            </v-card-subtitle>
            <v-row no-gutters dense fluid>
                <v-col cols="12" xs="8" sm="6" md="3" lg="3" xl="2">
                    <YearPicker v-model="selectedYear" />
                </v-col>
            </v-row>
        </v-card>
        <tabla-membresias :membresias="this.contratos" :actions="tableActions"
            @action-selected="onActionSelected"></tabla-membresias>
        <v-dialog v-model="dialogRenovar" max-width="80%" persistent>
            <v-card>
                <v-card-title class="text-h6">Generar renovación</v-card-title>
                <v-card-text>
                    <p>
                        Se generara la renovación de <b>{{ MembresiaSelect.Id }}</b> con vigencia incial de <b>
                            {{ new Date(new Date(MembresiaSelect.FecIniVig).setFullYear(new
                                Date(MembresiaSelect.FecIniVig).getFullYear() + 1))
                                .toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' }) }}</b>.
                                <br/>
                        Plan: <b>{{ MembresiaSelect.Plan }}</b>
                        con las coberturas de <b>{{ MembresiaSelect.Coberturas }}</b>. <br> Titular: <b>{{
                            MembresiaSelect.Titular }}</b><br/>
                        pases actuales: <b>{{ MembresiaSelect.NumCitas }}</b>, monto urgencia actual: <b>{{ $formatCurrency(MembresiaSelect.MontoUrgencias) }}</b>
                    </p>
                    <renovacio-componet :tipo-inicial="MembresiaSelect.Id"
                        @submit-form="recibirDatos"></renovacio-componet>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="dialogRenovar = false">CERRAR</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import RenovacioComponet from "@/components/Forms/RenovacioComponet.vue";
import { fechaMexico } from "@/utils/date";

export default {
    components: {
        TablaMembresias: () => import('@/components/tableMembresias.vue'),
        YearPicker: () => import('@/components/selectAnioComponent.vue'),
        RenovacioComponet
    },
    watch: {
        selectedYear(val) {
            if (val) {
                this.getRenovaciones()
            }
        }
    },
    data() {
        return {
            MembresiaSelect: {},
            contratos: [],
            selectedYear: fechaMexico(),
            tableActions: [
                'Renovar',
                'No renovar',
                'Enviar notificación'
            ],
            dialogRenovar: false,
            datosRecibidos: null,
        }
    },
    created() {
        this.getRenovaciones()
    },
    methods: {
        async getRenovaciones() {
            this.$http.get(`renovacion/buscar?fecha=${this.selectedYear}`)
                .then(response => {
                    if (response.status === 200) {
                        this.contratos = [...response.data]
                    }
                })
                .catch(() => {
                })
                .finally(() => {
                });
        },
        onActionSelected(action, item) {
            this.MembresiaSelect = { ...item }
            console.log(item)
            switch (action) {
                case 'Renovar':
                    this.dialogRenovar = true
                    break;
                case 'NO RENOVAR':
                    break;
                case 'ENVIAR NOTIFICACION':
                    break;
                default:
                    break;
            }
        },
        recibirDatos(datos) {
            this.datosRecibidos = datos;
            console.log("Datos del hijo:", datos);
        }
    }
}
</script>

<style lang="scss" scoped></style>